import { z } from 'zod';

export const documentSchema = z.object({
  idDocument: z.number(),
  Data: z.string().optional(),
  FileName: z.string(),
  idMIMEType: z.number(),
});

export type IDocument = z.infer<typeof documentSchema>;
